import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    datetime: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    const { name, contact, email, datetime } = formData;
    return (
      name.trim() !== "" &&
      contact.length >= 10 &&
      /\S+@\S+\.\S+/.test(email) &&
      datetime.trim() !== ""
    );
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!isValid()) return alert("Please fill all fields correctly");

  const scriptURL = "https://script.google.com/macros/s/AKfycbyDdc8Ts6CvpfrOYMmGc-zH37rsCP9i-Jp_1kc8r66CQ6sXynHXKpgo1Ghder-OgCgWbg/exec";

  try {
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    const response = await fetch(scriptURL, {
      method: "POST",
      body: formDataToSend,
    });

    if (response.ok) {
      setSubmitted(true);
      setFormData({
        name: "",
        contact: "",
        email: "",
        datetime: "",
      });

      setTimeout(() => setSubmitted(false), 5000);
    } else {
      alert("Failed to submit form. Please try again.");
    }
  } catch (error) {
    console.error("Form submit error", error);
    alert("There was an error submitting the form.");
  }
};


  return (
    <div className="contact-page">
      <div className="contact-banner">
        <h1>Contact Us Today</h1>
      </div>

      <section className="contact-section-1">
        <div className="contact-call-to-action">
          <h2>Let us connect you</h2>
          <p>We’d love to help you plan your next trip. Fill in your details and our team will get in touch.</p>

          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="contact"
              placeholder="Contact Number"
              value={formData.contact}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email ID"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="datetime-local"
              name="datetime"
              value={formData.datetime}
              onChange={handleChange}
              required
            />
            <button type="submit">Submit</button>
            {submitted && <p className="success-msg">Thank you for reaching out. Our team will connect you on the selected slot.</p>}
          </form>
        </div>
      </section>

      <section className="contact-section-2">
        <h2>Reach Us</h2>
        <p>📞 Phone: 6389421663, 8533873389</p>
        <p>📱 WhatsApp: 6389421663</p>
        <div className="social-icons">
          <a href="https://instagram.com/single._.tap" target="_blank" rel="noreferrer">📷</a>
          <a href="https://facebook.com/" target="_blank" rel="noreferrer">📘</a>
          <a href="https://wa.me/916389421663" target="_blank" rel="noreferrer">💬</a>
          <a href="https://youtube.com/" target="_blank" rel="noreferrer">▶️</a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
